"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dogna": {
    "4e16eaff": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "chioutmartin": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2f26063": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "chioutpupin": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de7ecf41": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "chioutzuquin": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9eeb82f": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "piccolcolle": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "237b87f1": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "plagnis": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65af7e11": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "prerit": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49380930": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "prerit-di-sopra": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "732a418c": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "skipSearch": false
    }],
    "saletto": [{
      "hkey": "a871d4ee",
      "slug": "dogna",
      "name": "Dogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;